import styled from 'styled-components';

import { color } from '@creditornot/cb-ingredients/design-tokens';

import { RowExpand } from './RowExpand';
import { RowMenu } from './RowMenu';
import { TRowModel, TableRowAction } from './types';
import { Stack } from '../Stack';

const IconsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  width: 100%;
`;

const RowMenuAndExpanderColumn = styled(Stack)`
  position: sticky;
  right: 0;
  background: ${color.bg};
  z-index: 1;
  padding: 12px 8px;
`;

const RowMenuAndExpanderIcons = styled(IconsContainer)`
  display: flex;
  width: 100%;
  height: 100%;
`;

type Props<Row> = {
  getRowMenu?: (record: Row) => TableRowAction<Row>[];
  record: Row;
  handleExpandedToggle?: (rowId: string) => void;
  hasMenuExpandColumn: boolean;
  isExpanded: boolean;
  hasSubComponent: boolean;
};

export const RowMenuExpand = <Row extends TRowModel<Row>>({
  getRowMenu,
  record,
  handleExpandedToggle,
  hasMenuExpandColumn,
  isExpanded,
  hasSubComponent,
}: Props<Row>) => {
  if (!hasMenuExpandColumn) {
    return null;
  }

  return (
    <RowMenuAndExpanderColumn
      role="cell"
      alignItems="flex-end"
      justifyContent="flex-end"
      className="content-container"
    >
      <RowMenuAndExpanderIcons className="row-menu-expand">
        <RowExpand
          isExpanded={isExpanded}
          canExpand={hasSubComponent}
          toggleExpanded={() => {
            if (handleExpandedToggle) {
              handleExpandedToggle(record.id);
            }
          }}
        />
        <RowMenu items={getRowMenu?.(record) ?? []} record={record} />
      </RowMenuAndExpanderIcons>
    </RowMenuAndExpanderColumn>
  );
};
